document.addEventListener('variant:change', function(event) {
  const variant = event.detail.variant;
  const customTailorDiv = document.querySelector('.custom-tailor');

  if (!customTailorDiv) return;

  const inputs = customTailorDiv.querySelectorAll('input, select, textarea');

  if (variant.title.includes("CUSTOM") || variant.title.includes("Custom")) {
    customTailorDiv.style.display = 'block';
    inputs.forEach(input => {
      input.disabled = false;
    });
  } else {
    customTailorDiv.style.display = 'none';
    inputs.forEach(input => {
      input.disabled = true;
    });
  }
});